import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { AylaDevicesList } from '../../devices/ayla-switches/AylaDevicesList';
import { Weather } from '../Weather';
import { WelcomeMessage } from '../WelcomeMessage';
import { SunriseSunset } from './SunriseSunset';

export function AylaOnlyHome() {
  const { t } = useTranslation();

  return (
    <Box data-testid="ayla-only-home-page">
      <Flex justifyContent="space-between">
        <SunriseSunset />
        <Weather shouldShowIcon={false} />
      </Flex>
      <WelcomeMessage />
      <AylaDevicesList sortBy="ALPHABETICAL" title={t('Devices.in use').toUpperCase()} state="closed" />
    </Box>
  );
}
